/**
 * Class representing a client classification.
 */
export default class ClientClassification {
  /**
   * Create a client classification.
   * @param {number} id - The unique identifier for the client classification.
   * @param {string} onlineTitle - The online title for the client classification.
   * @param {string} rateUnitType - The rate unit type (e.g., Hourly).
   * @param {Object} extraValidation - The extra validation settings.
   * @param {number} extraValidation.minimumDurationInMins - The minimum duration in minutes.
   * @param {string} extraValidation.earliestEndTime24hr - The earliest end time in 24-hour format.
   * @param {number} extraValidation.defaultBreakInMins - The default break in minutes.
   * @param {boolean} extraValidation.shouldShowBreaks - Whether breaks should be shown.
   */
  constructor(id, onlineTitle, rateUnitType, extraValidation) {
    /**
     * @property {number} id - The unique identifier for the client classification.
     */
    this.id = id

    /**
     * @property {string} onlineTitle - The online title for the client classification.
     */
    this.onlineTitle = onlineTitle

    /**
     * @property {string} rateUnitType - The rate unit type (e.g., Hourly).
     */
    this.rateUnitType = rateUnitType

    /**
     * @property {Object} extraValidation - The extra validation settings.
     */
    this.extraValidation = {
      minimumDurationInMins: extraValidation?.minimumDurationInMins,
      earliestEndTime24hr: extraValidation?.earliestEndTime24hr,
      defaultBreakInMins: extraValidation?.defaultBreakInMins,
      shouldShowBreaks: extraValidation?.shouldShowBreaks,
    }
  }
}
